import Product from '@/entities/Product';
import ProductFL from '@/entities/ProductFL';

export default class ProductsTransformer {
  static transformOne(item) {
    return new Product(item);
  }

  static transformOneFL(item) {
    return new ProductFL(item);
  }

  static transformList(items) {
    return items.map((e) => ProductsTransformer.transformOne(e));
  }

  static transformListFL(items) {
    return items.map((e) => ProductsTransformer.transformOneFL(e));
  }
}
